import React, { useState, useEffect } from "react";
import Header from "../../componentes/header/header";
import imgFundo from './imgHome/fundoHome1.png';
import { Helmet } from "react-helmet";
import JsonContainer from "../../componentes/containerJson/ContainerJson";
import FinalComponent from "../../componentes/EndPage/Final";
import PurpleBanner from "../../componentes/homeData/infoSobrevidas";
import CompFundadores from "../../componentes/Fundadores/Fundadores";
import JsonData from "./Publicacoes.json";  
import jsonDataFundadores from './fundadores.json';
import homeData from './traducao.json'; 

function Home() {
    const [lang, setLang] = useState(localStorage.getItem("siteLanguage") || "pt"); 

    const handleLanguageChange = (newLang) => {
        setLang(newLang);
        localStorage.setItem("siteLanguage", newLang); 
        window.location.reload(); 
    };

    useEffect(() => {
        const browserLang = navigator.language.split("-")[0];
        if (!localStorage.getItem("siteLanguage")) {
            localStorage.setItem("siteLanguage", browserLang);
        }
    }, []);

    const homeDataLang = homeData[lang] || homeData["pt"];
    const jsonDataLang = JsonData[lang] || JsonData["pt"]; 
    const fundadoresDataLang = jsonDataFundadores[lang] || jsonDataFundadores["pt"]; 

    return (
        <>
            <Header handleLanguageChange={handleLanguageChange} />

            <Helmet>
                <title>{homeDataLang?.home_title || "Home | Sobrevidas ACS"}</title>
            </Helmet>

            <div className="flex flex-row justify-between mx-[15%] mt-[10.2%] mb-[5%] z-[4]
                            max-[768px]:flex-col max-[768px]:items-center max-[768px]:mx-[5%] max-[768px]:mt-[20%]">
                <div className="min-w-[30%] flex-1 text-left 
                                max-[768px]:text-center max-[768px]:w-[90%]">
                    <p className="text-[27px] font-semibold text-[#f8b1ed] mt-[25px] 
                                  max-[768px]:text-[22px] md:text-[28px] lg:text-[30px]">
                        {homeDataLang?.sobrevidas_title || "Sobrevidas"}
                    </p>
                    <p className="font-bold text-[27px] text-white mt-[12px] 
                                  max-[768px]:text-[20px] max-[768px]:leading-relaxed 
                                  md:text-[28px] lg:text-[30px] xl:text-[32px]">
                        {homeDataLang?.conteudo || "Programa de prevenção do câncer de lábio, de cavidade oral e de orofaringe: processo de intervenção e custo-efetividade"}
                    </p>
                </div>

                <div className="max-[768px]:mt-[8%]">
                    <img 
                        src={imgFundo} 
                        alt="fundoHomePage"
                        className="relative w-full h-auto 
                                   max-[768px]:w-[90%] max-[768px]:mx-auto max-[768px]:left-0
                                   md:w-[95%] lg:w-[100%]"
                    />
                </div>
            </div>

            <h2 className="text-[30px] text-[#B040B1] font-extrabold inline-block relative 
                           mt-[5%] mb-[5%] 
                           max-[768px]:text-[24px] max-[768px]:text-center max-[768px]:w-full
                           md:mt-[5%] md:mb-[5%] 
                           lg:mt-[6%] lg:mb-[6%] 
                           xl:mt-[6%] xl:mb-[6%]">
                {homeDataLang?.recent_publications || "Publicações Recentes"}
                <span
                  className="absolute left-[-25%] bottom-[-1px] w-[150%] h-[45px] z-[-20] rounded-[50px]
                             shadow-[5px_5px_10px_rgba(0,0,0,0.2)] 
                             max-[768px]:left-[5%] max-[768px]:w-[90%]
                             md:left-[-15%] md:w-[130%] 
                             lg:left-[-10%] lg:w-[120%]"
                  style={{
                    background: "linear-gradient(to right, rgba(106, 13, 173, 0.4), rgba(255, 102, 178, 0.4))"
                  }}
                  aria-hidden="true"
                />
            </h2>

            <div className="text-left bg-white p-[2%] mx-[10%] mb-[8%] mt-[3%] 
                            border-l-[10px] border-[#6A0DAD] 
                            shadow-[5px_5px_10px_rgba(0,0,0,0.2)] 
                            rounded-[2vh] 
                            max-[768px]:mt-[10%] max-[768px]:mb-[20%] max-[768px]:mx-[5%]">
                <JsonContainer data={jsonDataLang} />
            </div>

            <PurpleBanner />

            <div className="flex justify-center my-[5%]">
  <h3 className="relative text-[30px] text-[#B040B1] font-extrabold text-center max-[768px]:text-[24px]">
    {homeDataLang?.our_coordinators || "Nossos Coordenadores"}
    <span
      className="absolute left-[-25%] bottom-[-1px] w-[150%] h-[45px] z-[-10] rounded-[50px] shadow-[5px_5px_10px_rgba(0,0,0,0.2)]"
      style={{
        background: "linear-gradient(to right, rgba(106, 13, 173, 0.3), rgba(255, 102, 178, 0.3))"
      }}
      aria-hidden="true"
    />
  </h3>
</div>


            <CompFundadores data={fundadoresDataLang} />
            <FinalComponent />
        </>
    );
}

export default Home;
